// extracted by mini-css-extract-plugin
export default {"container":"WhiteContainer_container__9PMyW"};